
import React, { useEffect, useRef, useState } from 'react'
import Filter from '@/pages/dashboard/components/Filter'
import useLockValue from '@/pages/dashboard/components/Filter/FilterBase/hooks/useLockValue'
import { filterValueInit } from '@/pages/dashboard/utils/utils';

import { FORM_MAP } from '@/pages/dashboard/pages/realtime/_config/constant';
import useRealtimeRevenueDefaultFilterVal from '@/pages/dashboard/filterPageComponents/realtime/realtimeRevenueFilterDefault';

/**
 * 
 * @param props 
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns 
 */

const realtimeRevenueFilter = (props) => {
  const { filterConfirm, filterReset, setFilterLoading, filterInit, filterLoading, setIsZoneTimeInit, timeZone = '+0', buttonLogConfig } = props;
  const defaultValue = useRealtimeRevenueDefaultFilterVal(timeZone);
  const formValueRef = useRef<any>(null)
  const { lockCacheValue, defaultExtendsKeyList, getPageLockDefaultValue } = useLockValue({
    supportTimeTypeList: ['day'],
    timePickerType: 'single',
  })

  const extendsFormValue = getPageLockDefaultValue(defaultValue, defaultExtendsKeyList)
  //   const [isZoneTimeInit, setIsZoneTimeInit] = useState(false)
  const formValInit = {
    ...defaultValue,
    ...(extendsFormValue || {})
  };
  const [formValue, setFormValue] = useState({});


  // 根据游戏时区初始化默认时间
  useEffect(() => {
    if (timeZone === '' || filterLoading) return
    let filterVal = {
      ...(formValInit || {}),
      [FORM_MAP.SINGLE_TIME]: defaultValue[FORM_MAP.SINGLE_TIME],
      [FORM_MAP.CONTRAST_DAY]: defaultValue[FORM_MAP.CONTRAST_DAY],
    }
    if (lockCacheValue) {
      filterVal = {
        ...filterVal,
        ...(extendsFormValue || {})
      };
    }
    filterVal = { ...filterVal, ...formValueRef.current }
    setFormValue(filterVal)
    // filterInit && filterInit(filterVal)
    setIsZoneTimeInit && setIsZoneTimeInit(true)
  }, [JSON.stringify(defaultValue), timeZone, filterLoading])


  const handleConfirm = (value) => {
    setFormValue(value);
    filterConfirm && filterConfirm(value)
  }

  const handleReset = (value) => {
    setFormValue(value);
    filterConfirm && filterReset(value)
  }

  const handleInit = ({ defaultValue }) => {
    const initFormValue = filterValueInit(formValInit, defaultValue);
    formValueRef.current = initFormValue;
    filterInit(initFormValue)
    setFormValue(initFormValue)
    setFilterLoading(false)
  }


  return <Filter
    value={formValue}
    defaultValue={defaultValue}
    onInit={handleInit}
    onlyTimePicker={true}
    buttonLogConfig={buttonLogConfig}
    timePickerList={[
      { type: 'singleTime', key: 'singleTime' },
      { type: 'contrastDay', key: 'contrastDay' },
    ]}
    onConfirm={handleConfirm}
    onReset={handleReset}
  // onLoading={setFilterLoading}
  />
}

export default realtimeRevenueFilter